(function(window, app, overwatch, $, _){
	var hero_details = {};

	//Needed for iOS to show first frame of video.
	hero_details.loadBackgroundVideo = function loadBackgroundVideo() {
		$('.video-background-wrapper .video-background-vid').load();
	};

	hero_details.setupMediaEvents = function setupMediaEvents() {
		$(".media-thumbnail").on("click",function() {
			var mediaType = $(this).data('media-type');

			switch (mediaType) {
				case 'youtube':
					var videoId = $(this).data("yt-id");
					app.helpers.loadVideoIntoFrame(videoId);
					break;
				case 'img':
					app.helpers.loadImageIntoFrame($(this).attr('href'));
					break;
				default:
					return true;
					break;
			}
			return false;
		});
	};

	hero_details.loadTabs = function() {
		var currentUrlHash = window.location.hash.substr(1),
			$details = $('#details'),
			heroVideo = $details.find(".hero-detail-video"),
			heroBg = $details.find(".hero-detail-background"),
			tabs = $("#details-tabs");
		var hasLinkTab = function() {
			switch(currentUrlHash) {
				case "overview":
				case "story" :
					return true;
				default :
					return false;
			}
		}();
		var hero = this.hero;
		this.tabs = new Foundation.Tabs(tabs);

		// change story background when story tab selected
		tabs.on('change.zf.tabs', function toggleStoryBackground() {
			var $tab = $(this).find('[aria-selected="true"]');
			var tabName = $tab.attr('aria-controls');
			if (tabName === 'story') {
				heroVideo.removeClass("is-active");
				heroBg.addClass("is-active");

				//analytics tracking on story tab
				if(window.dataLayer) {
					window.dataLayer.push({
						"event": "heroStoryTab",
						"tab":{
							"name": hero
						}
					});
				}
			} else {
				heroVideo.addClass("is-active");
				heroBg.removeClass("is-active");
			}
		});

		if(hasLinkTab){
			this.tabs.selectTab('#'+currentUrlHash);
		}
	};

	hero_details.loadShowcase = function loadShowcase() {
		var $showcase = $('.ability-showcase');
		var abilityShowcase = new overwatch.AbilityShowcase('.ability-showcase');
		var init = false;
		var playing = false;

		var resizeFn = _.debounce(function toggleShowcaseByVisibility() {
			var visible = $showcase.is(':visible');
			if (visible && !init) {
				// visible, needs initialization
				abilityShowcase.init();
				init = true;
				playing = true;
			} else if (visible && !playing) {
				// visible, but stopped and needs to play
				abilityShowcase.play();
				playing = true;
			} else if (!visible) {
				// not visible, just stop
				abilityShowcase.stop();
				playing = false;
			}
		}, 250);

		$(window).on('resize', resizeFn);

		// kick off init script
		resizeFn();
	};

	hero_details.init = function init(heroId, media) {
		this.hero = heroId;
		this.setupMediaEvents();
		this.loadTabs();
		this.loadShowcase();
		this.initHeroesGallery(media);
		this.loadBackgroundVideo();
	};

	hero_details.initHeroesGallery = function initHeroesGallery(media) {
		var $gallery = $('[data-js-media-gallery=hero]');
		var mediaItems = $gallery.find("[data-media-id]");
		var loadMoreButton = $('[data-load-more-media]');

		var showAllMediaItems = function() {
			$gallery.removeClass("is-partial");
			loadMoreButton.remove();
		};

		if (mediaItems.length > 4) {
			loadMoreButton.on('click', function (e) {
				showAllMediaItems();
			});
		} else {
			showAllMediaItems();
		}

		var gallery = overwatch.gallery.get('hero');
		_.each(media, function(media, key){
			gallery.add(media);
		});
	};

	app.extend({ hero_details: hero_details });

}(window, window.app, window.overwatch, window.jQuery, window._));
